import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LxlibUtilModule } from '@lxlib/util';

@NgModule({
  imports: [CommonModule, LxlibUtilModule],
})
export class ZipModule {}
